<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">Assign Entities</h3>
    </div>
  </div>
  <div class="card-body">
    <mat-form-field appearance="fill" class="w-100 mb-4">
      <mat-label>{{ 'DOCS_MODULE.DOCUMENT.ENTITY_TYPE' | translate }}</mat-label>
      <mat-select #entityTypeSelect multiple disabled>
        <mat-option *ngFor="let type of entityTypes" [value]="type">{{
          stringUtils.formatEnumString(type)
        }}</mat-option>
      </mat-select>
    </mat-form-field>
    <div class="w-100">
      <kt-general-autocomplete
        #entityAutocomplete
        [label]="'DOCS_MODULE.DOCUMENT.ENTITIES' | translate"
        [chipList]="true"
        [dataPath]="'data'"
        [control]="entityAutocomplete"
        [objects]="entityAutocomplete.value"
        [loadItemsFunction]="getEntityAutocomplete"
        [optionFormatter]="stringUtils.formatEntityOptionActiveInactive"
        [chipOptionFormatter]="stringUtils.formatEntityValueActiveInactive"
        [formatNewObjectFn]="formatNewEntity"
        [readOnly]="false"
      ></kt-general-autocomplete>
    </div>
  </div>
  <div class="card-footer d-flex justify-content-end">
    <button
      mat-raised-button
      cdkFocusInitial
      style="width: 100px !important"
      class="btn btn-sm btn-light"
      (click)="closeDialog($event)"
    >
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button
      mat-raised-button
      style="width: 100px !important"
      class="btn btn-sm btn-primary ml-4"
      (click)="submit($event)"
    >
      {{ 'GLOBAL.SAVE' | translate }}
    </button>
  </div>
</div>
